<script>
  export default {
    components: {},
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
    computed: {

    }
  }
</script>
<template>
  <div :class="$style.ArticleKeyWord">
    <h2 class="ArticleKeyWord__title">關鍵字</h2>
    <div>
      <h4 v-for="(item, index) in list" :key="index" class="badge-gray">
        <router-link
          class="badge-gray__link"
          :to="{
            name: 'search',
            params: {
              tagTitle: item.title,
            },
            query: {
              tag: item.alias,
            },
          }"
        >
          {{ item.title }}
        </router-link>
      </h4>
    </div
    >
  </div>
</template>
<style lang="scss" module>
  .ArticleKeyWord {
    width: 100%;
    padding-right: 3.125rem;
    padding-left: 3.125rem;
    margin-left: auto;
    @include max-lg {
      padding-right: 0;
      padding-left: 0;
    }
    // margin-bottom: 3rem;
    :global {
      .ArticleKeyWord {
        &__title {
          margin-bottom: 1.25rem;
          font-size: 1.3125rem;
          @include max-md {
            margin-bottom: 1rem;
            font-size: 1rem;
          }
        }
      }

      .badge-gray {
        display: inline-block;
        margin-right: 0.625rem;
        margin-bottom: 1rem;
        font-size: 0.875rem;
        font-weight: 200;
        // color: $color-gray-6;

        // line-height: 1;

        background-color: rgba($color-gray-5, 10%);

        &__link {
          display: inline-block;
          padding: 0.63rem 0.8125rem;
          color: $color-gray-6;
          border-radius: 5px;
          font-weight: 400;
          &:hover {
            color: $color-primary;
            text-decoration: none;
            // background-color: rgba(140, 151, 172, 0.2);
          }
          @include max-md {
            font-size: 0.75rem;
            padding: 0.56rem 0.75rem
          }
        }

        // + .badge-gray {
        //   margin-left: 0.625rem;
        // }
      }
    }
  }
</style>
